export const CATS_ABANDONED_CART_INTERNAL_ROOT_PATH = "/abandoned-cart/internal";

export const CATS_ABANDONED_CART_INTERNAL_FRESH_SUFFIX = "/fresh";
/** /abandoned-cart/internal/fresh */
export const CATS_ABANDONED_CART_INTERNAL_FRESH_PATH =
  CATS_ABANDONED_CART_INTERNAL_ROOT_PATH + CATS_ABANDONED_CART_INTERNAL_FRESH_SUFFIX;

export const CATS_ABANDONED_CART_INTERNAL_SCOOP_SUFFIX = "/scoop";
/** /abandoned-cart/internal/scoop */
export const CATS_ABANDONED_CART_INTERNAL_SCOOP_PATH =
  CATS_ABANDONED_CART_INTERNAL_ROOT_PATH + CATS_ABANDONED_CART_INTERNAL_SCOOP_SUFFIX;
